import {Logout} from 'modules/Auth';

export default Logout;
